import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { getUrlWithVersion } from '../../../api/api'
import { logout } from '../auth/logout'

export const changeCurrentUserPassword = createAsyncThunk<
    void,
    { access_token: string | null; oldPassword: string; newPassword: string },
    ThunkConfig<string>
>('changePassword', async (data, thunkAPI) => {
    const {
        dispatch,
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    try {
        await api.post(
            getUrlWithVersion(`/users/current/change_password`),
            data
        )
        throwSuccessMessage(`Password changed`)
        dispatch(logout())
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to change password')
    }
})
